<template>
  <div class="action_fire">
    <div class="action_fire_container">
      <div class="action_fire_item_card">
        <div class="card_header">
          <div class="card_title">
            <span class="main_label">{{ $t('action_fire_count') }}</span>
            <span class="range_hint">({{ limit.count[0] }}~{{ limit.count[1] }})</span>
          </div>
        </div>
        <div class="card_content">
          <ActionInput v-model="fireCount" type="number" :min="limit.count[0]" :max="limit.count[1]" />
        </div>
      </div>

      <div class="action_fire_item_card">
        <div class="card_header">
          <div class="card_title">
            <span class="main_label">{{ $t('action_fire_title_interval') || $t('action_fire_interval') }}</span>
            <span class="range_hint">({{ limit.interval[0] }}~{{ limit.interval[1] }}ms)</span>
          </div>
        </div>
        <div class="card_content">
          <ActionInput v-model="fireInterval" type="number" :min="limit.interval[0]" :max="limit.interval[1]" unit="ms" @focus="handleFocus" @blur="handleBlur" />
        </div>
      </div>
    </div>
    <div class="action_fire_tips">
      <div class="tips_content">
        <svg viewBox="0 0 24 24" class="tips_icon" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span>{{ $t('action_fire_desc') }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
const defaultData = {
  count: 3,
  interval: 10,
}
export const fireCount = ref(defaultData.count)
export const fireInterval = ref(defaultData.interval)
</script>
<script setup lang="ts">
import ActionInput from './ActionInput.vue'
import { setData } from '@/service/driver/data'
import { operate } from '@/service/driver/operate'
import { onMounted, ref, watch } from 'vue'
const limit = {
  count: [0, 3],
  interval: [1, 255],
}
watch(fireCount, (value) => {
  if (value > limit.count[1]) {
    fireCount.value = limit.count[1]
  } else if (!value || value < limit.count[0]) {
    fireCount.value = limit.count[0]
  }
})
watch(fireInterval, () => {
  handleFireInterval()
})
const handleFireInterval = () => {
  if (fireInterval.value > limit.interval[1]) {
    fireInterval.value = limit.interval[1]
  } else if (fireInterval.value < limit.interval[0]) {
    if (intervalInputStatus.value == false) {
      fireInterval.value = limit.interval[0]
    }
  }
}
// 间隔:输入框的状态
const intervalInputStatus = ref(false)
const handleFocus = () => {
  intervalInputStatus.value = true
}
const handleBlur = () => {
  intervalInputStatus.value = false
  handleFireInterval()
}
onMounted(() => {
  setFireData()
})
// 使用 getter 函数形式：每次 Layout 被替换时都能获取最新的 KeyMapFire 引用
watch(
  () => setData.getActionData.KeyMapFire,
  (_) => {
    setFireData()
  },
)
const setFireData = () => {
  const { KeyMapFire } = setData.getActionData
  const values = KeyMapFire?.[operate.currentKey.value]
  if (values?.length === 2) {
    // 解构赋值提取 fireCount 和 fireInterval
    ;[fireCount.value, fireInterval.value] = values
  } else {
    // 使用默认值
    fireCount.value = defaultData.count
    fireInterval.value = defaultData.interval
  }
}
</script>

<style lang="less" scoped>
.action_fire {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 580px;
  margin: 0 auto;

  .action_fire_container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    .action_fire_item_card {
      background: var(--glass-surface-bg);
      backdrop-filter: var(--glass-surface-blur);
      border-radius: var(--radius-m);
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      transition: var(--transition-base);

      &:hover {
        background: var(--color-white);
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
      }

      .card_header {
        .card_title {
          display: flex;
          align-items: baseline;
          gap: 6px;

          .main_label {
            font-size: 14px;
            font-weight: 600;
            color: var(--color-dark);
          }

          .range_hint {
            font-size: 12px;
            color: var(--color-text-hint);
            font-weight: 400;
          }
        }
      }

      .card_content {
        display: flex;
        justify-content: flex-start;
      }
    }
  }

  .action_fire_tips {
    display: flex;
    justify-content: center;

    .tips_content {
      background: rgba(var(--color-brand-1-rgb), 0.05);
      border-radius: var(--radius-s);
      padding: 10px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--color-text-hint);
      font-size: 11px;
      line-height: 1.4;
      border: 1px solid rgba(var(--color-brand-1-rgb), 0.1);

      .tips_icon {
        width: 14px;
        height: 14px;
        color: var(--brand-color-pure);
        flex-shrink: 0;
      }
    }
  }
}
</style>
